import * as React from 'react';
import * as Yup from 'yup';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { Formik, FormikProps } from 'formik';
import { FormInput } from 'common/components/form/FormInput';

interface AddBranchCountDialogProps {
  isOpen?: boolean;
  onConfirm: (count: number) => void;
  onCancel: () => void;
}
interface AddBranchCountValues {
  count: number;
}

export class AddBranchCountDialog extends React.Component<AddBranchCountDialogProps> {
  validationSchema = Yup.object().shape({
    count: Yup.number()
      .required('Required')
      .integer('Must be an integer')
      .min(1, 'Must be at least 1'),
  });

  initialValues() {
    return {};
  }

  handleSubmit = (values: AddBranchCountValues) => {
    this.props.onConfirm(values.count);
  };

  render() {
    return (
      <Modal size="sm" isOpen={!!this.props.isOpen} toggle={this.props.onCancel} keyboard={true}>
        <Formik
          initialValues={this.initialValues()}
          validationSchema={this.validationSchema}
          onSubmit={this.handleSubmit}
          render={(form: FormikProps<AddBranchCountValues>) => (
            <form onSubmit={form.handleSubmit}>
              <ModalHeader toggle={this.props.onCancel}>Add Branches</ModalHeader>
              <ModalBody>
                <FormInput type="number" id="count" name="count" label="Number of Branches to Add" />
              </ModalBody>
              <ModalFooter>
                <div>
                  <Button color="secondary" onClick={this.props.onCancel}>
                    Cancel
                  </Button>{' '}
                  <Button color="primary" type="submit">
                    Add
                  </Button>
                </div>
              </ModalFooter>
            </form>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Orgs/AddBranchCountDialog.tsx